import LoadingSpinner from '../elements/loading-spinner';
const { __, _x, _n, _nx } = wp.i18n;

export default class ProfilePictureUpload extends wp.element.Component {
  constructor( props ) {
    super( props );
    this.state = {
			error: null,
			errorMsg: null,
			isLoading: false,
			pictureSrc: props.pictureSrc,
    };
		this.handleSubmit = this.handleSubmit.bind( this );
  };

	initLoading() {
		this.setState( {
			error: null,
			errorMsg: null,
			isLoading: true,
		} );
	};

	handleSubmit( event ) {
		event.preventDefault();
		this.initLoading();

		var formData = new FormData();
		var fileField = document.querySelector('input[type="file"]');

		formData.append( 'portrait', fileField.files[0] );

		const opts = {
			headers: {
				'X-WP-Nonce': wpApiSettings.nonce,
			},
			method: 'POST',
			body: formData,
		};

		fetch(
			wpApiSettings.root + 'iportal/v1/profile_picture',
			opts
		).then(
			response => response.json()
		).then(
			response => {
				if ( 'picture' in response === false ) {
					throw new Error( response.message );
				}
				this.setState( {
					isLoading: false,
					pictureSrc: response['picture'],
				} );
			}
		).catch(
			error => {
				console.error( 'Error:', error )
				this.setState({
					error: 'GENERAL',
					errorMsg: error.message,
					isLoading: false,
				});
			}
		);
	};

	render() {
		return (
			<form method="post" className={this.state.isLoading ? 'form--loading' : ''} onSubmit={this.handleSubmit}>
				{ this.state.isLoading && <LoadingSpinner /> }
				{ this.state.error && <div className="alert alert-danger">{__( "Could not upload picture: ") + this.state.errorMsg}</div> }
				{ this.state.pictureSrc && <img src={this.state.pictureSrc}/> }
				<div className="form-group">
					<label htmlFor="profile_picture">{__('Upload your profile picture (JPEG, 500x500 pixel or more)')}</label>
					<input type="file" name="profile_picture"
					disabled={this.state.isLoading}
					className="form-control"/>
					<span>{__('Maximum file size')}: {this.props.maxUploadSize/1024/1024} MB</span>
				</div>
				<button className="btn btn-primary" type="submit">{__( 'Upload' )}</button>
			</form>
		);
	};
}
